import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {OrdersConfigForm} from './model/orders-config.form';
import {IdValue} from '../../../../../core/model/id-value';
import {BanksAccount} from './model/bank-account';
import {FormGroup} from "@angular/forms";

@Injectable()
export class OrdersConfigService {

  constructor(private http: HttpClient) {
  }

  public upsert(form: OrdersConfigForm, clientId: number): Observable<void> {
    return this.http.post<void>(`/api/orders-config?clientId=${clientId}`, form);
  }

  public load(clientId: number): Observable<OrdersConfigForm> {
    return this.http.get<OrdersConfigForm>(`/api/orders-config?clientId=${clientId}`);
  }

  public upsertLogo(logo: File, clientId: number): Observable<void> {
    const logoData = new FormData();
    logoData.append('logo', logo);
    return this.http.post<void>(`/api/orders-config/logo?clientId=${clientId}`, logoData)
  }

  public deleteLogo(clientId: number): Observable<void> {
    return this.http.delete<void>(`/api/orders-config?clientId=${clientId}`);
  }

  public loadSubClients(): Observable<IdValue<string>[]> {
    return this.http.get<IdValue<string>[]>('/api/orders-config/sub-clients');
  }

  public getByDatePrefix(ordersIds: number[]): Observable<string> {
    return this.http.post(`/api/orders-config/prefix-date`, ordersIds, {responseType: 'text'});
  }

  public hasSymfoniaActive(): Observable<boolean> {
    return this.http.get<boolean>(`/api/orders-config/symfonia`);
  }

  public hasKsefActive(): Observable<boolean> {
    return this.http.get<boolean>(`/api/orders-config/ksef`);
  }

  public getClientBankAccounts(): Observable<BanksAccount[]> {
    return this.http.get<BanksAccount[]>(`/api/orders-config/bank-accounts`);
  }

  public saveKsefCredentials(form: FormGroup, crtFile: File, keyFile: File) {
    const data = new FormData();
    data.append('crtFile', crtFile);
    data.append('keyFile', keyFile);
    data.append('form', new Blob([JSON.stringify(form.value)], {type: 'application/json'}));
    return this.http.post<void>(`/api/orders-config/ksef-credentials`, data)
  }

  public deleteKsefCredentials(clientId: number): Observable<void> {
    return this.http.post<void>(`/api/orders-config/ksef-remove`, clientId)
  }
}
